import React from 'react'
import * as AUTH_ACTION from 'constant/action/auth'
import * as LOGIN_TYPE from 'constant/login-type'
import * as LOADER_ACTIONS from 'constant/action/loader'
import { createAction } from 'redux-actions'
import { history } from 'js/redux/middleware/history'
import { notification } from 'antd'
import { ClockCircleTwoTone } from '@ant-design/icons'
import * as NUMBER from 'js/constant/number'
import * as ROUTES from 'js/constant/routes'

const updateAuthState = createAction(AUTH_ACTION.UPDATE_AUTH_STATE)
const updateGeneralDidError = createAction(AUTH_ACTION.UPDATE_GENERAL_DID_ERROR)
const updateLoginSubmitting = createAction(LOADER_ACTIONS.UPDATE_LOGIN_SUBMITTING)
let sessionTimerId
let alertTimeoutId

export const isLoggedIn = () => async (dispatch, getState, { auth }) => {
  try {
    const response = await auth.isLoggedIn()
    dispatch(updateAuthState({ loginCheckComplete: true }))
    if (response && response.success) {
      const {
        router: {
          location
        }
      } = getState()

      const user = response.user

      startSessionTimer(dispatch)
      listenForRouteChange(dispatch)
      dispatch(qlikAuth())

      dispatch(updateAuthState({ isAuthenticated: true, user }))
      history.replace(location?.state?.from)
    }
  } catch (error) {
    console.error(error)
    dispatch(updateAuthState({ loginCheckComplete: true }))
  }
}

export const login = (credentials) => async (dispatch, getState, { auth }) => {
  try {
    dispatch(updateLoginSubmitting(true))
    const { url } = await auth.login({ ...credentials, login_type: LOGIN_TYPE.EXTERNAL })
    dispatch(updateAuthState({ loginCheckComplete: false }))
    sessionStorage.setItem('qlik', 'true')
    window.location.href = url
  } catch (error) {
    dispatch(updateLoginSubmitting(false))
    dispatch(updateGeneralDidError(true))
    console.error(error)
  }
}

export const qlikAuth = () => async (dispatch, getState, { auth }) => {
  try {
    if (!sessionStorage.getItem('qlik')) {
      const {
        auth: authState
      } = getState()
      const { url } = await auth.qlikAuth({ user: authState.user })
      if (url) {
        sessionStorage.setItem('qlik', 'true')
      }
    }
  } catch (error) {
    dispatch(updateLoginSubmitting(false))
    dispatch(updateGeneralDidError(true))
    console.error(error)
  }
}
export const getLandingPageUrl = (siteUuid) => async (dispatch, getState, { auth }) => {
  try {
    const { url } = await auth.handoffToken(siteUuid)
    return url
  } catch (error) {
    console.error(error)
  }
}

export const logout = () => async (dispatch, getState, { auth }) => {
  try {
    dispatch(updateAuthState({ loginCheckComplete: false }))

    await auth.logout()
    dispatch(updateAuthState({ isAuthenticated: false, loginCheckComplete: true, user: undefined }))
    history.push('/')
  } catch (error) {
    dispatch(updateAuthState({ isAuthenticated: false, loginCheckComplete: true, user: undefined }))
  }
}

const listenForRouteChange = (dispatch) => {
  history.listen((location) => {
    if (history.location.pathname !== ROUTES.LOGIN) {
      startSessionTimer(dispatch)
    }
  })
}

const openNotificationWithIcon = (type) => {
  notification.open({
    description:
      'Your session will expire in 2 minutes.',
    duration: NUMBER.ONE_HUNDRED_TWENTY,
    icon: <ClockCircleTwoTone style={{ color: '#490C4E' }} />,
    message: 'Session Expiry'
  })
}

const logoutNotification = (type) => {
  notification.open({
    description:
      'Your session expired due to inactivity.',
    duration: NUMBER.ZERO,
    icon: <ClockCircleTwoTone twoToneColor='#7f2fd1' />,
    message: 'Session Expiry'
  })
}

const startAlertTimer = () => {
  if (alertTimeoutId !== undefined) {
    clearTimeout(alertTimeoutId)
  }

  alertTimeoutId = setTimeout(() => {
    openNotificationWithIcon('info')
  }, NUMBER.FIFTY_EIGHT_MINUTES)
}

const startSessionTimer = (dispatch) => {
  startAlertTimer()
  if (sessionTimerId !== undefined) {
    clearTimeout(sessionTimerId)
  }

  sessionTimerId = setTimeout(() => {
    dispatch(logout())
    logoutNotification('info')
  }, NUMBER.ONE_HOUR)
}
